import React, { FC } from 'react';
import { Input } from '@scuf/common';
import { IAircraftDetailsInputProps } from './IAircraftDetailsInputProps';

export const AircraftDetailsInput: FC<IAircraftDetailsInputProps> = ({ name, error, value, disabled, onChange }) => (
  <Input name={name} fluid={true} value={value} onChange={onChange} error={error} disabled={disabled} />
);
